import { render, staticRenderFns } from "./confirmedinvoices.vue?vue&type=template&id=3b651ac2"
import script from "./confirmedinvoices.vue?vue&type=script&lang=js"
export * from "./confirmedinvoices.vue?vue&type=script&lang=js"
import style0 from "./confirmedinvoices.vue?vue&type=style&index=0&id=3b651ac2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports